import { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(
    localStorage.getItem("language") || "en"
  );

  //  RTL support; lang attribute also drives date/number formatting (utils/locale.js)
  useEffect(() => {
    document.dir = lang === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = lang;
    try {
      localStorage.setItem("language", lang);
    } catch (e) {
      // storage unavailable (private mode) — language still applies for this visit
    }
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);